import { createRouter, createWebHashHistory } from 'vue-router'

//createWebHistory
const routes = [
  { 
    path: '/', 
    name: 'root', 
    component: () => import('@/views/square/TimeLine.vue')
  },
  { path: '/keyword-search',
    name: 'keyword-search-result',
    component: () => import('@/views/keyword-search/keyword-search-result.vue') 
  },
  // 広場コンポーネント
  { 
    path: '/square', 
    name: 'square', 
    component: () => import('@/views/square/TimeLine.vue')
  },
  { 
    path: '/square/hashtag/:hashtagId', 
    name: 'square/hashtag', 
    component: () => import('@/views/square/TimeLine.vue') 
  },
  { 
    path: '/entry/:entryId?', 
    name: 'EntryDetail', 
    component: () => import('@/views/detail/EntryDetail.vue') 
  },
  // { path: '/entry/edit/:entryId?', name: 'entry/edit', component: EntryEdit },

  // 仮登録完了コンポーネント
  { 
    path: '/temporary-sign-in-done/:mail?', 
    name: '仮登録完了コンポーネント',
    component: () => import('@/views/registration/TemporarySignInDone.vue') 
  },
  // 本登録コンポーネント
  {
    path: '/sign-in/:id',
    name: '本登録コンポーネント',
    component: () => import('@/views/registration/SignIn.vue')
  },
  // パスワード再発行コンポーネント
  { 
    path: '/reissue-password', 
    name: 'パスワード再発行コンポーネント', 
    component: () => import('@/views/password/ReissuePassword.vue') 
  },
  // パスワード再発行完了コンポーネント
  { 
    path: '/reissue-password-done/:mail?', 
    name: 'パスワード再発行完了コンポーネント', 
    component: () => import('@/views/password/ReissuePasswordDone.vue') 
  },
  // 設置コンポーネント
  { 
    path: '/settings', 
    name: 'アカウント設定',
    component: () => import('@/views/settings/SettingsIndex.vue') 
  },
  // マイスペース
  { 
    path: '/myspace/:accountId', 
    name: 'MyspaceTimeLine', 
    component: () => import('@/views/myspace/MyspaceTimeLine.vue'),
  },
  { 
    path: '/myspace/:accountId/:myspaceDivisionId?', 
    name: 'side/myspace', 
    component: () => import('@/views/myspace/MyspaceTimeLine.vue') 
  },
  // お知らせ一覧
  { 
    path: '/notifications', 
    name: 'お知らせ一覧', 
    component: () => import('@/views/notifications/NotificationsIndex.vue') 
  },
  // サークルトップ
  { 
    path: '/circle',
    name: 'circle-top',
    component: () => import('@/views/circle/CircleTop.vue') 
  },
  { 
    path: '/circle/:circlesDivisionId?', 
    name: 'side/circle', 
    component: () => import('@/views/circle/CircleTop.vue') 
  },

  // サークルtime-line
  { 
    path: '/circle/time-line/:circleMode/:circleId?', 
    name: 'circle/time-line', 
    component: () => import('@/views/circle/time-line/CircleTimeLine.vue') 
  },
  { 
    path: '/circle/time-line/:circleMode/:circleId/:hashtagId?', 
    name: 'circle/time-line/hashtagId', 
    component: () => import('@/views/circle/time-line/CircleTimeLine.vue') 
  },
  // サークル招待承認
  { 
    path: '/circle/approval/:inviteId', 
    name: 'circle/approval', 
    component: () => import('@/views/circle/approval/ApproveInvitation.vue') 
  },
  // サークル編集
  { 
    path: '/circle/edit/:circleId?', 
    name: 'circle/edit', 
    component: () => import('@/views/circle/CircleEdit.vue')
  },
  // フッター
  { path: '/about-cotolike', component: () => import('@/views/support/AboutCotolike.vue') },
  { path: '/contact-us', component: () => import('@/views/support/ContactUs.vue') },
  { path: '/privacy-policy', component: () => import('@/views/support/PrivacyPolicy.vue') },
  { path: '/terms-service', component: () => import('@/views/support/TermsService.vue') },
  { path: '/help', component: () => import('@/views/support/TomotsukuHelp.vue') },
  // 管理者メニュー
  { path: '/admin', component: () => import('@/views/admin/AdminIndex.vue') },
  { path: '/admin/accounts', component: () => import('@/views/admin/AccountLists.vue') },
  { path: '/admin/account/edit/:accountId', component: () => import('@/views/admin/AccountEdit.vue') },
  { path: '/admin/hashtags', component: () => import('@/views/admin/HashtagLists.vue') },
  { path: '/admin/hashtag/edit/:hashtagId', component: () => import('@/views/admin/HashtagEdit.vue') },
  { path: '/admin/mail', component: () => import('@/views/admin/SendMail.vue') },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.afterEach((/*to, from*/) => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
})
export default router
